var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9349 7.62138C19.8928 7.48731 19.781 7.38953 19.6464 7.36916L13.1856 6.39545L10.2964 0.324342C10.2364 0.197676 10.1121 0.117676 9.97635 0.117676C9.84064 0.117676 9.71599 0.197676 9.65635 0.324342L6.76671 6.39582L0.305993 7.36953C0.171351 7.3899 0.0599219 7.48731 0.0174219 7.62175C-0.0243638 7.75545 0.0102791 7.90286 0.107779 8.00101L4.78314 12.7269L3.67921 19.4003C3.65635 19.5392 3.71135 19.6795 3.82099 19.7625C3.93135 19.8462 4.07742 19.8569 4.19706 19.7906L9.97635 16.6403L15.7549 19.7906C15.8071 19.8192 15.8646 19.8332 15.9214 19.8332C15.9953 19.8332 16.0689 19.8095 16.1314 19.7625C16.2414 19.6795 16.2964 19.5392 16.2731 19.4003L15.1696 12.7273L19.8449 8.00101C19.9421 7.90212 19.9771 7.75508 19.9349 7.62138Z",
    fill: "#FAEA0A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9b766b04.svg";
export { ForwardRef as ReactComponent };